import React from "react";

const Search = ({ placeholder = "Search..", onChange = (value) => { }, hideButton = false }) => {
    return (
        <form className="sticky top-0 z-20">
            <div className="relative">
                <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                    <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                    </svg>
                </div>
                <input type="search" id="default-search" className="block w-full p-2 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-pink-500 focus:border-pink-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={placeholder} required
                    onChange={(e) => onChange(e.target.value)}
                />
                <button hidden={hideButton} type="submit" className="text-white absolute end-2.5 bottom-[7px] bg-pink-500 hover:bg-pink-600 focus:ring-4 focus:outline-none focus:ring-pink-300 font-medium rounded-lg text-sm px-2 py-0.5 dark:bg-pink-600 dark:hover:bg-pink-700 dark:focus:ring-pink-800">検索</button>
            </div>
        </form>
    )
};

export default Search;